import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-62f4d9ff"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teachingcenter-warp w"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "link-list"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, " 教案中心 ")], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_5 = {
  class: "list-warp"
};
import CardHeader from '../../components/CardHeader.vue';
import ListItem from '../../teachingCenterList/components/ListItem/index.vue';
export default {
  props: {
    menu: {
      type: Object,
      default: () => ({})
    }
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    provide('menuInfo', ref(props.menu));
    const caseList = ref([]);

    const getHomeCaseList = async () => {
      const res = await $http.getCaseList({
        sort_type: 2
      });
      console.log('首页-教案', res);
      caseList.value = res.content;
    };

    getHomeCaseList();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CardHeader, {
        link: `/teachingCenterList.html?name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`
      }, {
        left: _withCtx(() => [_hoisted_2]),
        right: _withCtx(() => [_hoisted_3, _hoisted_4]),
        _: 1
      }, 8, ["link"]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caseList.value, item => {
        return _openBlock(), _createBlock(ListItem, {
          class: "item",
          key: item.id,
          caseData: item
        }, null, 8, ["caseData"]);
      }), 128))])]);
    };
  }

};